import Axios from 'axios'
import {featureUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_features (context) {
    Axios.get(featureUrls.getAllFeatures).then(function (response) {
      context.commit('GET_ALL_FEATURES', response.data)
    })
  },
  get_features (context, publicId) {
    Axios.get(featureUrls.getFeatures + publicId).then(function (response) {
      context.commit('GET_FEATURES', response.data)
    })
  },
  assign_feature (context, data) {
    Axios.post(featureUrls.assignFeature, data).then(function () {
      context.dispatch('get_user_type_features', data.role_public_id)
      context.dispatch('get_not_assigned_features', data.role_public_id)
    })
  },
  detach_feature (context, data) {
    Axios.post(featureUrls.removeFeature, data).then(function () {
      context.dispatch('get_user_type_features', data.role_public_id)
      context.dispatch('get_not_assigned_features', data.role_public_id)
    })
  },
  get_deleted_features (context) {
    Axios.get(featureUrls.getDeletedFeature).then(function (response) {
      context.commit('GET_DELETED_FEATURES', response.data)
    })
  },
  get_feature (context, publicId) {
    Axios.get(featureUrls.getFeature + publicId).then(function (response) {
      context.commit('GET_FEATURE', response.data)
    })
  },
  post_feature (context, data) {
    Axios.post(featureUrls.postFeature, data).then(function () {
      context.dispatch('get_all_features')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  update_feature (context, data) {
    Axios.post(featureUrls.editFeature, data).then(function () {
      context.dispatch('get_all_features')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      // console.log(error.data)
    })
  },
  delete_feature (context, publicId) {
    Axios.get(featureUrls.deleteFeature + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_FEATURES', response.data)
      router.push({
        name: 'Module.DeletedFeatures'
      })
    })
  },
  restoreFeature (context, publicId) {
    Axios.get(featureUrls.restoreFeature + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FEATURES', response.data)
      router.push({
        name: 'Module.Features'
      })
    })
  }
}
